module.exports = __webpack_public_path__ + "static/media/qusion-mobile.acd03df4.mp4";